import React from 'react';
import { Typography } from '@mui/material';

/**
 * Apenas o título — subtítulo e ações ficam na linha de filtros (ver
 * `SupportFilters`), seguindo o mesmo padrão de "admin/articles".
 */
export default function SupportHeader() {
  return (
    <Typography variant="h5" sx={{ fontWeight: 700, color: '#1a1a1a', lineHeight: 1, mb: 0.4 }}>
      Suporte
    </Typography>
  );
}
